export default {
    goBack() {
        // @ts-ignore
        if (window.CityLife) {
            // @ts-ignore
            window.CityLife.goback()
        } else {
            let message = {
                param: 'back'
            };
            // @ts-ignore
            window.webkit.messageHandlers.goback.postMessage(message);
        }
    },

    goHome() {
        // @ts-ignore
        if (window.CityLife) {
            // @ts-ignore
            window.CityLife.gohome()
        } else {
            let message = {
                param: 'gohome'
            };
            // @ts-ignore
            window.webkit.messageHandlers.gohome.postMessage(message);
        }
    },

    payByUrl(url: any) {
        // @ts-ignore
        if (window.CityLife && window.CityLife.payByUrl) {
            // @ts-ignore
            window.CityLife.payByUrl(url);
        } else {
            window.location.href = url
        }
    }
}
